@if (shouldShow$ | async) {
  <div class="fullscreen-overlay">
    <div class="content">
      @if (statusNew()) {
        <img
          ngSrc="assets/graphic-business-cert-needed.svg"
          alt=""
          priority="priority"
          height="142"
          width="186" />
        <h4 class="text-white">Business certificate pending</h4>
        <p>
          Please make sure your business certificate has been uploaded to complete registration. Your functionality will
          be limited until registration is complete.
        </p>
        <a
          routerLink="/help-desk"
          class="btn btn-primary d-inline-block">
          Contact Support
        </a>
      } @else if (statusCertNotVerified()) {
        <img
          ngSrc="assets/graphic-error.svg"
          priority="priority"
          alt=""
          height="142"
          width="186" />
        <h4 class="text-white">Business certificate could not be verified</h4>
        <p>Please upload your latest business certificate or contact support.</p>

        <div class="row justify-content-center">
          <div class="col-auto">
            <a
              routerLink="/help-desk"
              class="btn btn-secondary">
              Contact Support
            </a>
          </div>
          <div class="col-auto">
            <a
              routerLink="/sign-up/business-certificate-retry"
              class="btn btn-primary">
              Upload Certificate
            </a>
          </div>
        </div>
      } @else if (statusCertAuthPending()) {
        <img
          ngSrc="assets/graphic-directors-auth-needed.svg"
          priority="priority"
          alt=""
          height="142"
          width="186" />
        <h4 class="text-white">Directors’ authorisation {{ statusDirectorApproval() ? 'processing' : 'needed' }}</h4>
        <p>
          Accepting an authorisation is required to complete your registration. <br />
          The authorisation link sent to your directors will expire in 7 days.
        </p>
        <div class="row gx-2 justify-content-center">
          <div class="col-auto">
            <a
              routerLink="/help-desk"
              class="btn btn-outline-light">
              Contact Support
            </a>
          </div>
          <div class="col-auto resend-button text-start">
            @if (status !== BusinessStatus.DirectorApproval) {
              <app-resend-btn
                btnID="resendDirectorAuthBtn"
                btnClass="btn btn-primary"
                sentMessage="Authorisation was resent successfully"
                label="Resend authorisation"
                requestMessage="You can resend again in"
                [resend$]="resend$"></app-resend-btn>
            }
          </div>
        </div>
      } @else {
        <img
          ngSrc="assets/graphic-directors-auth-needed.svg"
          priority="priority"
          alt=""
          height="142"
          width="186" />
        <h4 class="text-white mb-5">
          @if (statusPaymentMissed()) {
            Payment Missed
          } @else if (statusDecommissionPending()) {
            Decommission Pending
          } @else if (statusDecommissioned()) {
            Decommissioned
          } @else {
            There is a problem with your account status
          }
        </h4>
        <div class="row gx-2 justify-content-center">
          <div class="col-auto">
            <a
              [href]="helpCenterUrl"
              rel="noopener"
              target="_blank"
              id="contactSupportBtn"
              class="btn btn-outline-light">
              Contact Support
            </a>
          </div>
        </div>
      }
    </div>
  </div>
}
